import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';
import { TrendingUp as TrendingUpIcon, People as PeopleIcon } from '@mui/icons-material';
import { useCountAnimation } from '../../hooks/useCountAnimation';


const NewPatientsCard = ({ count }) => {
  const { t } = useTranslation();  // Translation hook
  // count animation hook for a more dynamic feel when numbers update
  const animatedCount = useCountAnimation(count, 1500);

  return (
    <Card
      sx={{
        background: 'rgba(255, 255, 255, 0.95)',
        height: '100%',
        boxShadow: '0 10px 40px rgba(102, 126, 234, 0.3)',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 15px 50px rgba(102, 126, 234, 0.4)',
        },
        transition: 'all 0.3s ease',
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="body2" sx={{ color: 'grey.600' }}>
            {t('onboardedThisWeek')}
          </Typography>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: 'success.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'success.main',
            }}
          >
            <TrendingUpIcon />
          </Box>
        </Box>

        {/* Value */}
        <Typography
          sx={{
            fontSize: '4rem',
            fontWeight: 700,
            color: 'success.main',
            lineHeight: 1,
            mb: 2,
          }}
        >
          +{animatedCount}
        </Typography>

        {/* Footer */}
        <Typography sx={{ color: 'grey.600', mb: 2 }}>
          {t('newPatients')}
        </Typography>

        {/* Badge */}
        <Chip
          icon={<PeopleIcon sx={{ fontSize: '1rem' }} />}
          label={t('greatWeek')}
          sx={{
            background: 'success.light',
            color: 'success.dark',
            fontWeight: 500,
            '& .MuiChip-icon': {
              color: 'success.dark',
            },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default NewPatientsCard;